import { useMemo } from 'react';
import {
  ApiClient,
  BannerComponent,
  DynamicComponentTypes,
  EntityCollection,
  PageFooterComponent,
  RelatedFile,
  SEO,
} from '../api/content';
import { createPageQuery, unwrap } from './factory';

export interface ArticleTopic {
  topic: string;
  newsArticles: EntityCollection<NewsArticle>;
}

export interface NewsArticle {
  name: string;
  bannerComponent: BannerComponent;
  articleContent: Array<DynamicComponentTypes>;
  articleTopics: EntityCollection<ArticleTopic>;
  flipImage: RelatedFile;
  description: string;
  date: string;
  slug: string;
  pageFooter?: PageFooterComponent;
  SEO: SEO;
}

function getNewsArticles(nameQuery: string, selectedTopics: string[]) {
  const filters: any = {};

  // Add name filter if nameQuery is provided
  if (nameQuery) {
    filters.name = {
      $containsi: nameQuery,
    };
  }

  // Add topic filter only if selectedTopics has items
  if (selectedTopics && selectedTopics.length > 0) {
    filters.articleTopics = {
      topic: {
        $in: selectedTopics,
      },
    };
  }

  return ApiClient.get<EntityCollection<NewsArticle>>('/news-articles', {
    params: {
      filters,
      sort: ['date:desc'], // Sort by date in descending order
      pagination: { limit: -1 },
      populate: ['flipImage', 'articleTopics'],
    },
  });
}

export function getNewsArticlesQuery(nameQuery: string, selectedTopics: string[]) {
  return createPageQuery({
    queryKey: ['news', nameQuery, selectedTopics.sort().join(',')],
    queryFn: unwrap(() => getNewsArticles(nameQuery, selectedTopics)),
  });
}

export function useNewsArticlesQuery(nameQuery: string, selectedTopics: string[]) {
  const { useQuery } = useMemo(
    () => getNewsArticlesQuery(nameQuery, selectedTopics),
    [nameQuery, selectedTopics]
  );

  return useQuery();
}
